<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">
    <h2 class="modal-title">{{'configuration_purpose' | translate}}</h2>
    <h2 class="modal-subtitle">{{'please_select_config' | translate}}</h2>

    <ion-radio-group [value]="selectedOption" (ionChange)="selectOption($event.detail.value)">
      <ion-list class="selection-list" lines="none">
        <!-- Entire Window Option -->
        <ion-item class="selection-item" [class.selected]="selectedOption === 'entire-window'" button detail="false">
          <ion-radio slot="start" value="entire-window" labelPlacement="end" mode="md">
            <!-- Content goes INSIDE the ion-radio -->
            <div class="radio-content">
              <ion-label class="option-label">
                <h3>{{'entire_window' | translate}}</h3>
                <p>Configuring the entire window will allow you to calculate all available results</p>
              </ion-label>
            </div>
          </ion-radio>
        </ion-item>

        <!-- Glass Only Option -->
        <ion-item class="selection-item" [class.selected]="selectedOption === 'glass-only'" button detail="false">
          <ion-radio slot="start" value="glass-only" labelPlacement="end" mode="md">
            <!-- Content goes INSIDE the ion-radio -->
            <div class="radio-content">
              <ion-label class="option-label">
                <h3>{{'glass_only' | translate}} @if (!isLoggedIn) {<ion-chip color="warning"> {{ 'login_required' |
                    translate }}</ion-chip> } </h3>
                <p>Configuring only the glass will only allow you to calculate SWS air simulation results</p>
              </ion-label>
            </div>
          </ion-radio>
        </ion-item>
      </ion-list>
    </ion-radio-group>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <!-- Button Container -->
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    @if (showLoginButton) {
    <ion-button class="next-btn" (click)="login()" expand="block">
      {{ 'login' | translate }}
    </ion-button>
    } @else {
    <ion-button class="next-btn" (click)="next()" [disabled]="disableNextBtn" expand="block">
      {{'next' |translate}}
    </ion-button>
    }
  </div>
</ion-footer>